<template>
  <a-modal :visible="visible" :width="500" title="编辑" :footer="null" @cancel="$emit('cancel')">
    <a-spin :spinning="spinning">
      <a-form :form="form" v-bind="formItemLayout" @submit="handlePost">
        <a-form-item label="关联用户">
          <div class="overflow-hidden">
            <a-input v-decorator="['p_user_name']" read-only @click="userFlag = true">
              <a-icon type="ellipsis" slot="suffix" style="font-size: 24px"></a-icon>
            </a-input>
          </div>
        </a-form-item>
        <a-form-item label="关联用户" v-show="false">
          <div class="overflow-hidden">
            <a-input-number v-decorator="['user_id']"></a-input-number>
          </div>
        </a-form-item>
        <!-- <a-form-item label="备注">
          <a-textarea v-decorator="['text']" autoSize></a-textarea>
        </a-form-item> -->
        <a-form-item :wrapperCol="{ span: 16, offset: 6 }">
          <a-button class="mr-6" type="primary" size="default" html-type="submit"> 提交</a-button>
          <a-button size="default" @click="$emit('cancel')">取消</a-button></a-form-item
        >
      </a-form>
    </a-spin>
    <UserSelect
      :visible="userFlag"
      @cancel="() => (userFlag = false)"
      @ok="userSelect"
    ></UserSelect>
  </a-modal>
</template>
<script>
  import { contract_puser_change } from '@/api/contract';
  import permission from '@/utils/permission';
  import UserSelect from './user-select.vue';
  export default {
    components: {
      UserSelect,
    },
    props: {
      visible: Boolean,
      info: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        formItemLayout: {
          labelCol: { span: 6 },
          wrapperCol: { span: 14 },
        },
        formUploadLayout: {
          labelCol: { span: 8 },
          wrapperCol: { span: 16 },
        },
        form: this.$form.createForm(this, { name: 'company' }),
        spinning: false,
        userFlag: false,
      };
    },
    watch: {
      visible(a) {
        if (a) {
          setTimeout(() => this.form.setFieldsValue(this.info), 1);
        }
      },
    },
    methods: {
      userSelect(e) {
        setTimeout(
          () =>
            this.form.setFieldsValue({
              p_user_name: e.name,
              user_id: e.id,
            }),
          1,
        );
        this.userFlag = false;
      },
      async handlePost(e) {
        e.preventDefault();
        this.form.validateFieldsAndScroll(async (err, values) => {
          if (!err) {
            if (values.name != values.owner) {
              this.$message.warning('开户许可证和营业执照不匹配,请重新上传');
              return;
            }
            try {
              this.spinning = true;
              let data = Object.assign(this.info, values);
              await contract_puser_change(data);
              this.$emit('ok');
            } catch (error) {
              this.$error({ title: '错误提示', content: error });
            } finally {
              this.$emit('cancel');
              this.spinning = false;
            }
          } else {
            console.log(values);
          }
        });
      },
    },
  };
</script>
<style scoped lang="less">
  :deep(.ant-row) {
    position: static;
  }
</style>
